@if (!isFloating) {
	<div class="language-switcher">
		@for (lang of languages; track lang) {
			<button type="button" (click)="setLang(lang)" [class.active]="isActive()(lang)" class="lang-button" [attr.lang]="lang">
				{{ labelKey(lang) | transloco }}
			</button>
		}
	</div>
}

@if (isFloating) {
	<div class="floating-lang-switcher">
		<button type="button" class="floating-toggle-btn" (click)="toggleFloatingMenu()" [class.open]="isFloatingMenuOpen()">
			<span class="current-flag">{{ labelKey(activeLang()) | transloco }}</span>
			<i class="pi pi-chevron-up" [class.rotated]="isFloatingMenuOpen()"></i>
		</button>
		@if (isFloatingMenuOpen()) {
			<div class="floating-menu">
				@for (lang of languages; track lang) {
					<button
						type="button"
						(click)="selectLanguage(lang)"
						[class.active]="isActive()(lang)"
						class="floating-lang-option"
						[attr.lang]="lang"
					>
						{{ labelKey(lang) | transloco }}
					</button>
				}
			</div>
		}
	</div>
}
